const populateData = ({ commit }, neighbourhoodData) => {
  const map = {
    center: {},
    style: '',
    project: {}
  };
  neighbourhoodData.section_content.forEach((content) => {
    switch (content.name) {
      case 'map_center': {
        map.center.lat = parseFloat(content.content.split(',')[0]);
        map.center.lng = parseFloat(content.content.split(',')[1]);
        break;
      }
      case 'snazzy': {
        map.style = content.content;
        break;
      }
      case 'project_location': {
        map.project.lat = parseFloat(content.content.split(',')[0]);
        map.project.lng = parseFloat(content.content.split(',')[1]);
        break;
      }
      default: {
        break;
      }
    }
  });

  const archSlides = neighbourhoodData.section_images.filter(img => img.type === 'heart');
  archSlides.sort((a, b) => parseInt(a.imageset_id, 10) - parseInt(b.imageset_id, 10));

  const poiList = neighbourhoodData.section_points.map((poi) => {
    const travelTime = JSON.parse(poi.link);
    return {
      id: poi.id,
      name: poi.name,
      lat: poi.x,
      lng: poi.y,
      type: neighbourhoodData.section_filters
        .find(type => type.id === poi.filter_id).filter_name,
      travelTime: {
        walk: travelTime.walk,
        transit: travelTime.transit,
        drive: travelTime.drive
      },
      orderId: poi.order_id,
      stars: travelTime.stars,
      address: poi.description
    };
  });

  const filters = {
    typeList: neighbourhoodData.section_filters.map(type => ({
      label: type.filter_name,
      slug: type.filter_name,
      active: false
    }))
  };

  commit('setMap', map);
  commit('setPoiList', poiList);
  commit('setFilters', filters);
  commit('setArchitecture', archSlides);
  commit('sortByOrderId');
  commit('setReady');
};

export default {
  populateData,
};



// WEBPACK FOOTER //
// ./src/store/modules/neighbourhood/actions.js